<template>
  <div>
    <div class="box mb20" v-if="$route.query.id">
      <el-page-header @back="$router.go(-1)"></el-page-header>
    </div>
    <el-card class="mb15" shadow="hover">
      <el-row>
        <el-input
          :placeholder="$t('search')"
          clearable
          v-model="filter.search"
          @keyup.enter.native="get_list"
        ></el-input>
      </el-row>
      <el-row class="mt20" type="flex" :gutter="20" align="middle">
        <span class="text">{{ $t('activity_userList.activity_type') }}:</span>
        <el-radio-group size="medium" v-model="filter.activity__type">
          <el-radio label>{{ $t('all') }}</el-radio>
          <el-radio :label="2">{{ activity_type(2) }}</el-radio>
          <el-radio :label="1">{{ activity_type(1) }}</el-radio>
        </el-radio-group>
      </el-row>
      <el-row class="mt20" type="flex" :gutter="20" align="middle">
        <span class="text">{{ $t('activity_userList.status') }}:</span>
        <el-radio-group size="medium" v-model="filter.status">
          <el-radio label>{{ $t('all') }}</el-radio>
          <el-radio :label="0">{{ status(0) }}</el-radio>
          <el-radio :label="1">{{ status(1) }}</el-radio>
          <el-radio :label="2">{{ status(2) }}</el-radio>
          <el-radio :label="3">{{ status(3) }}</el-radio>
          <el-radio :label="4">{{ status(4) }}</el-radio>
        </el-radio-group>
      </el-row>
      <el-row class="mt20" type="flex" align="middle">
        <el-button @click="get_list" type="primary" class="search">{{
          $t('search_zh')
        }}</el-button>
        <el-button @click="reset" type="info">{{
          $t('btnTip.reset')
        }}</el-button>
      </el-row>
    </el-card>
    <el-card>
      <div class="flexBC mb20">
        <div class="flex">
          <el-button type="primary" @click="dialogAddUserVisible = true"
            >신청자 추가</el-button
          >
          <div style="font-size:20px; margin-left: 8px;">
            체크 수: {{ selete.length }}
          </div>
        </div>
        <div>
          <el-dropdown class="mr10" @command="multiple_update">
            <el-button type="warning">일괄 승인 </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="1">{{
                $t('activity_userList.s1')
              }}</el-dropdown-item>
              <el-dropdown-item :command="2">{{
                $t('activity_userList.s2')
              }}</el-dropdown-item>
              <el-dropdown-item :command="3">{{
                $t('activity_userList.s3')
              }}</el-dropdown-item>
              <el-dropdown-item :command="4">{{
                $t('activity_userList.s4')
              }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" @click="outExe">{{
            $t('outExe')
          }}</el-button>
          <el-button type="primary" @click="outExeAll('activity_userList')"
            >전체출력</el-button
          >
        </div>
      </div>
      <my-table
        :columns="columns"
        :data="list_data.list"
        :showIndex="false"
        :showSelection="true"
        :cellStyle="{ padding: '6px 0' }"
        :headerCellStyle="{ background: 'rgba(51, 55, 68, 1)', color: '#fff' }"
        @emitSelection="allSelect"
        @sortChange="sort_change"
        v-if="showTable"
      >
        <template v-slot:user_address="slotProps">
          <div>
            {{ slotProps.callback.row.user_address }}
            {{ slotProps.callback.row.address_detail }}
          </div>
        </template>
        <template v-slot:activity_type="slotProps">
          <div>{{ activity_type(slotProps.callback.row.activity_type) }}</div>
        </template>
        <template v-slot:order_quantity="slotProps">
          <div>
            {{
              slotProps.callback.row.order_quantity
                ? slotProps.callback.row.order_quantity
                : 1
            }}
          </div>
        </template>
        <template v-slot:apply_reason="slotProps">
          <div>{{ slotProps.callback.row.apply_reason }}</div>
          <!-- <div :class="{'mutiple':!slotProps.callback.row.show}">{{slotProps.callback.row.apply_reason}}</div>
          <div @click="showMutiple(slotProps.callback.row)" class="more">{{slotProps.callback.row.show?'hide...':'more...'}}</div> -->
        </template>
        <template v-slot:status="slotProps">
          <el-tag :type="statusTag(slotProps.callback.row.status)">{{
            status(slotProps.callback.row.status)
          }}</el-tag>
        </template>
        <template v-slot:operation="slotProps">
          <!-- <el-button
            @click="handleClick('check',slotProps.callback.row)"
            type="success"
            size="mini"
          >신청사유</el-button> -->
          <el-tooltip
            v-if="
              slotProps.callback.row.status === 1 &&
                !slotProps.callback.row.order_id
            "
            class="item"
            effect="dark"
            :content="$t('btnTip').edit"
            placement="top"
          >
            <el-button
              @click="handleClick('edit', slotProps.callback.row)"
              icon="el-icon-edit-outline"
              type="primary"
              size="mini"
            ></el-button>
          </el-tooltip>

          <el-dropdown
            v-if="slotProps.callback.row.status === 0"
            class="mr10 ml10"
            @command="handleCommand"
          >
            <el-button type="warning" size="mini"
              >{{ $t('activity_userList.changeStatus') }}
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="[slotProps.callback.row, 1]">{{
                $t('activity_userList.s1')
              }}</el-dropdown-item>
              <el-dropdown-item :command="[slotProps.callback.row, 2]">{{
                $t('activity_userList.s2')
              }}</el-dropdown-item>
              <el-dropdown-item :command="[slotProps.callback.row, 3]">{{
                $t('activity_userList.s3')
              }}</el-dropdown-item>
              <el-dropdown-item :command="[slotProps.callback.row, 4]">{{
                $t('activity_userList.s4')
              }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <!-- <el-tooltip class="item" effect="dark" :content="$t('btnTip').delete" placement="top">
            <el-button
              @click="remove(slotProps.callback.row.id)"
              icon="el-icon-delete"
              type="danger"
              size="mini"
            ></el-button>
          </el-tooltip> -->
        </template>
      </my-table>
      <page
        :total="list_data.total"
        :page_size.sync="pageSize"
        :page.sync="page"
      />
    </el-card>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="500px">
      <form-page
        :ref-obj.sync="formInfo.ref"
        :data="formInfo.data"
        :field-list="formInfo.fieldList"
        :rules="formInfo.rules"
        :label-width="formInfo.labelWidth"
        :list-type-info="listTypeInfo"
        :disabled="formInfo.disabled"
      ></form-page>
      <span slot="footer" class="dialog-footer">
        <el-button @click="done" type="primary" class="ml30">{{
          $t('btnTip.submit')
        }}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="사용자 추가"
      :visible.sync="dialogAddUserVisible"
      width="500px"
    >
      <article>
        <div class="flex" style="gap: 4px">
          <div class="disable-input">
            <img src="@/assets/img/excel-color.png" alt="" />
            <p>add_user_event_template.xlsx</p>
          </div>
          <a href="/add_user_event_template.xlsx" download>
            <el-button type="default">다운로드</el-button>
          </a>
        </div>
        <p class="excel-desc">
          반드시 제공하는 엑셀 파일을 이용해 파일을 업로드 하세요.
        </p>
      </article>
      <article>
        <h3 class="form-label">파일 업로드</h3>
        <div class="input-container">
          <el-input
            v-model="excelFormData.name"
            placeholder="파일 형식 (xlsx)"
            readonly
          />
          <input
            ref="fileInput"
            type="file"
            accept=".xlsx,.xls"
            style="display: none"
            @change="handleFileChange"
          />
          <el-button type="default" @click="triggerFileInput"
            >파일 선택</el-button
          >
        </div>
      </article>

      <div class="button-container">
        <el-button type="default" @click="dialogAddUserVisible = false"
          >취소</el-button
        >
        <el-button type="primary" @click="addUserSubmit">등록하기</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mixin_list } from '@/mixins';
import myTable from '@/components/table';
import FormPage from '@/components/FormPage';
import page from '@/components/page';
import {
  activity_userList,
  edit_activity_userList,
  delete_activity_userList,
  multiple_update_activity_userList,
  add_user_activity,
} from '@/api/api';
const formInfoData = {
  refuse_reason: '',
};
export default {
  name: 'activity_userList',
  mixins: [mixin_list(activity_userList)],
  components: {
    page,
    myTable,
    FormPage,
  },
  data() {
    return {
      filter: {
        search: '',
        activity: this.$route.query.id,
        status: '',
        activity__type: '',
      },
      columns: [
        {
          label: 'ID',
          prop: 'id',
          sortable: true,
          width: 80,
        },
        {
          label: this.$t('activity_userList.create_time'),
          prop: 'create_time',
          sortable: true,
        },
        {
          label: this.$t('activity_userList.username'),
          prop: 'username',
          sortable: true,
        },
        {
          label: this.$t('activity_userList.real_name'),
          prop: 'real_name',
          sortable: true,
        },
        {
          label: this.$t('activity_userList.user_phone'),
          prop: 'user_phone',
          sortable: true,
        },
        {
          label: this.$t('activity_userList.user_address'),
          prop: 'user_address',
          slot: 'user_address',
          sortable: true,
        },
        {
          label: this.$t('activity_userList.user_address_code'),
          prop: 'user_address_code',
          sortable: true,
        },
        // {
        //   label: this.$t('activity_userList.address_detail'),
        //   prop: 'address_detail',
        //   sortable:true
        // },
        {
          label: this.$t('activity_userList.activity_title'),
          prop: 'activity_title',
          sortable: true,
        },
        {
          label: this.$t('activity_userList.activity_type'),
          prop: 'activity_type',
          slot: 'activity_type',
          sortable: true,
        },
        {
          label: this.$t('activity_userList.pay_amount'),
          sortable: true,
          prop: 'order_pay_amount',
        },
        {
          label: this.$t('activity_userList.coupon_title'),
          sortable: false,
          prop: 'coupon_title',
        },
        {
          label: this.$t('activity_userList.count'),
          sortable: false,
          prop: 'order_quantity',
          slot: 'order_quantity',
        },
        {
          label: this.$t('activity_userList.apply_reason'),
          sortable: true,
          prop: 'apply_reason',
          slot: 'apply_reason',
        },
        {
          label: this.$t('activity_userList.refuse_reason'),
          sortable: true,
          prop: 'refuse_reason',
        },
        {
          label: this.$t('activity_userList.status'),
          prop: 'status',
          slot: 'status',
          sortable: true,
          width: 100,
        },
        {
          label: this.$t('operation'),
          prop: '',
          width: 220,
          slot: 'operation',
          fixed: 'right',
        },
      ],
      formInfo: {
        ref: null,
        disabled: false,
        data: formInfoData,
        fieldList: [
          {
            label: this.$t('activity_userList').refuse_reason,
            value: 'refuse_reason',
            width: '260',
            type: 'textarea',
            className: 'el-form-block',
            required: true,
            hidden: false,
            showlimit: true,
            maxlength: 30,
          },
          // {
          //   label: '신청사유',
          //   value: "apply_reason",
          //   width: "260",
          //   type: "textarea",
          //   className: "el-form-block",
          //   required: false,
          //   hidden: false,
          // },
        ],
        rules: {},
        labelWidth: '120px',
      },
      listTypeInfo: {},
      dialogFormVisible: false,
      dialogAddUserVisible: false,
      which: '',
      showTable: true,
      excelFormData: { name: '' },
    };
  },
  computed: {
    title() {
      switch (this.which) {
        case 'add':
          return this.$t('btnTip').add;
        case 'edit':
          return this.$t('btnTip').edit;
      }
    },
  },
  methods: {
    showMutiple(row) {
      this.$set(row, 'show', !row.show);
    },
    async handleCommand(command) {
      if (command[1] === 1 && !command[0].order_id) {
        this.handleClick('special', [command[0]]);
      } else {
        await multiple_update_activity_userList({
          status: command[1],
          update_id: command[0].id + '',
        });
        this.get_list();
      }
    },
    statusTag(statusTag) {
      switch (statusTag) {
        case 0:
          return 'primary';
        case 1:
          return 'success';
        case 2:
          return 'info';
        case 3:
          return 'danger';
        case 4:
          return 'warning';
      }
    },
    status(status) {
      switch (status) {
        case 0:
          return this.$t('activity_userList.status0');
        case 1:
          return this.$t('activity_userList.status1');
        case 2:
          return this.$t('activity_userList.status2');
        case 3:
          return this.$t('activity_userList.status3');
        case 4:
          return this.$t('activity_userList.status4');
      }
    },
    activity_type(activity_type) {
      switch (activity_type) {
        case 1:
          return this.$t('activity_userList.activity_type2');
        case 2:
          return this.$t('activity_userList.activity_type1');
      }
    },
    async handleClick(type, data) {
      switch (type) {
        case 'edit':
          // this.formInfo.fieldList[0].hidden = false
          // this.formInfo.fieldList[1].hidden = true
          this.formInfo.data = { ...data };
          this.initRules();
          break;
        case 'special':
          this.formInfo.data = {
            status: 1,
            refuse_reason: '',
            update_id: data
              .map((item) => {
                return item.id;
              })
              .join(','),
          };
          break;
      }
      this.formInfo.disabled = type !== 'check' ? false : true;
      this.dialogFormVisible = true;
      this.which = type;
    },
    done() {
      switch (this.which) {
        case 'edit':
          this.formInfo.ref.validate(async (valid) => {
            if (valid) {
              await edit_activity_userList(this.formInfo.data);
              this.get_list();
            }
          });
          break;
        case 'special':
          this.formInfo.ref.validate(async (valid) => {
            if (valid) {
              await multiple_update_activity_userList(this.formInfo.data);
              this.get_list();
            }
          });
          break;
      }
      this.dialogFormVisible = false;
    },
    remove(id) {
      this.$confirm(
        this.$t('activity_userList.sureDeleteUser'),
        this.$t('tips'),
        {
          confirmButtonText: this.$t('btnTip.submit'),
          cancelButtonText: this.$t('btnTip.cancel'),
          type: 'warning',
        }
      )
        .then(async () => {
          const res = await delete_activity_userList(id);
          this.get_list();
        })
        .catch(() => {});
    },
    addUserSubmit() {
      // 파일을 읽거나 API로 전송
      const formData = new FormData();
      formData.append('file', this.excelFormData);

      add_user_activity(formData)
        .then(() => {
          window.location.reload();
        })
        .catch((e) => console.log(e));
    },
    async multiple_update(command) {
      if (this.selete.length === 0) {
        this.$message({
          message: '처리하시려는 옵션을 선택해 주세요.',
          type: 'warning',
        });
      } else {
        if (command === 1) {
          this.handleClick('special', [...this.selete]);
        } else {
          await multiple_update_activity_userList({
            status: command,
            update_id: this.selete
              .map((item) => {
                return item.id;
              })
              .join(','),
          });
          this.get_list();
        }
      }
    },
    triggerFileInput() {
      const fileInput = this.$refs.fileInput; // 숨겨진 input 참조
      if (fileInput) {
        fileInput.click(); // 파일 입력창 트리거
      }
    },
    handleFileChange(event) {
      const input = event.target;
      if (input.files && input.files.length > 0) {
        this.excelFormData = input.files[0];

        // 파일 크기 및 유형 확인
        if (
          this.excelFormData.type !==
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' &&
          this.excelFormData.type !== 'application/vnd.ms-excel'
        ) {
          alert('올바른 Excel 파일을 선택하세요.');
          return;
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.text {
  width: 100px;
  font-size: 16px;
}
.more {
  color: #409eff;
  cursor: pointer;
}
/deep/ label {
  margin-bottom: 0 !important;
}
.button-container {
  display: flex;
  margin-top: 40px;

  button {
    width: 100%;
    height: 50px;
  }
}
.form-label {
  font-family: 'Pretendard-Semibold';
  font-size: 16px;
  color: black;
  margin-bottom: 8px;
}
.input-container {
  display: flex;
  gap: 4px;

  .el-input {
    width: 100%;
  }

  /deep/.el-upload-list {
    display: none;
  }
}
.disable-input {
  display: flex;
  align-items: center;
  padding: 0 12px;
  width: 100%;
  height: 40px;
  gap: 8px;
  border: 1px solid #acb0b3;
  background-color: #f5f5f5;
  border-radius: 4px;

  img {
    width: 24px;
    height: 24px;
  }

  p {
    font-size: 16px;
    font-weight: 400;
    color: black;
  }
}

.excel-desc {
  font-size: 14px;
  margin-top: 4px;
  margin-bottom: 12px;
}
</style>
